import { create } from 'zustand';

export const useToastNotificationStore = create(set => ({
  focusedComment: null,
  setToastNotificationStore: (field, value) => set(prev => ({ ...prev, [field]: value }))
}));
